// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.book-list-cover-item {
  width: 400px;
  /* height: 200px; */
  float: left;
  overflow: hidden;
  position: relative;
}
.book-cover-item-header {
  width: 150px;
}
.book-cover-item-cover {
  /* height: 170px; */
  opacity: 1;
  width: 120px;
  margin: 5px 15px 15px 15px;
  cursor: pointer;
  /* overflow: hidden; */
  float: left;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 3px;
}
.book-cover-item-title {
  width: 240px;
  margin-top: 10px;
  height: 35px;
  font-size: 15px;
  line-height: 17px;
  opacity: 1;
  text-align: left;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  position: relative;
  float: left;
  font-weight: 500;
}
.book-cover-item-author {
  width: 240px;
  margin-top: 5px;
  height: 18px;
  font-size: 13px;
  line-height: 17px;
  opacity: 0.8;
  text-align: left;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
  position: relative;
  float: left;
}
.book-cover-item-config {
  width: 105px;
  height: 35px;
  position: relative;
  bottom: 71px;
  left: 15px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  font-size: 15px;
  opacity: 1;
  cursor: pointer;
  animation: fade-in 0.1s ease-in 0s 1;
}

@keyframes fade-in {
  0% {
    opacity: 0;
    transform: translateY(20px);
  }
  100% {
    opacity: 1;
    transform: translateY(0px);
  }
}

.book-cover-item-desc {
  width: 240px;
  margin-top: 5px;
  font-size: 13px;
  line-height: 17px;
  opacity: 0.8;
  text-align: left;
  position: relative;
  float: left;
  height: 52px;
}
.book-cover-item-desc-detail {
  width: 100%;
  height: 100%;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
}
@keyframes slide-down {
  0% {
    transform: translateY(-20px);
    opacity: 0;
  }
  100% {
    transform: translateY(0px);
    opacity: 1;
  }
}
@keyframes slide-down-rotate {
  0% {
    transform: translateY(-20px);
    opacity: 0;
  }
  100% {
    transform: translateY(0px);
    opacity: 1;
  }
}
@keyframes slide-up {
  0% {
    transform: translateY(20px);
    opacity: 0;
  }
  100% {
    transform: translateY(0px);
    opacity: 1;
  }
}
.reading-percentage-char {
  display: inline-block;
  transform: scale(0.5) translate(-5px, 2px);
}
`, "",{"version":3,"sources":["webpack://./src/components/bookCoverItem/bookCoverItem.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,YAAY;AACd;AACA;EACE,mBAAmB;EACnB,UAAU;EACV,YAAY;EACZ,0BAA0B;EAC1B,eAAe;EACf,sBAAsB;EACtB,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,UAAU;EACV,gBAAgB;EAChB,uBAAuB;EACvB,oBAAoB;EACpB,4BAA4B;EAC5B,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,oBAAoB;EACpB,4BAA4B;EAC5B,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,aAAa;EACb,6BAA6B;EAC7B,mBAAmB;EACnB,eAAe;EACf,UAAU;EACV,eAAe;EACf,oCAAoC;AACtC;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,0BAA0B;EAC5B;AACF;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;AACA;EACE,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,oBAAoB;EACpB,4BAA4B;EAC5B,qBAAqB;EACrB,gBAAgB;AAClB;AACA;EACE;IACE,4BAA4B;IAC5B,UAAU;EACZ;EACA;IACE,0BAA0B;IAC1B,UAAU;EACZ;AACF;AACA;EACE;IACE,4BAA4B;IAC5B,UAAU;EACZ;EACA;IACE,0BAA0B;IAC1B,UAAU;EACZ;AACF;AACA;EACE;IACE,2BAA2B;IAC3B,UAAU;EACZ;EACA;IACE,0BAA0B;IAC1B,UAAU;EACZ;AACF;AACA;EACE,qBAAqB;EACrB,0CAA0C;AAC5C","sourcesContent":[".book-list-cover-item {\n  width: 400px;\n  /* height: 200px; */\n  float: left;\n  overflow: hidden;\n  position: relative;\n}\n.book-cover-item-header {\n  width: 150px;\n}\n.book-cover-item-cover {\n  /* height: 170px; */\n  opacity: 1;\n  width: 120px;\n  margin: 5px 15px 15px 15px;\n  cursor: pointer;\n  /* overflow: hidden; */\n  float: left;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: 3px;\n}\n.book-cover-item-title {\n  width: 240px;\n  margin-top: 10px;\n  height: 35px;\n  font-size: 15px;\n  line-height: 17px;\n  opacity: 1;\n  text-align: left;\n  text-overflow: ellipsis;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 2;\n  overflow: hidden;\n  position: relative;\n  float: left;\n  font-weight: 500;\n}\n.book-cover-item-author {\n  width: 240px;\n  margin-top: 5px;\n  height: 18px;\n  font-size: 13px;\n  line-height: 17px;\n  opacity: 0.8;\n  text-align: left;\n  text-overflow: ellipsis;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 1;\n  overflow: hidden;\n  position: relative;\n  float: left;\n}\n.book-cover-item-config {\n  width: 105px;\n  height: 35px;\n  position: relative;\n  bottom: 71px;\n  left: 15px;\n  display: flex;\n  justify-content: space-around;\n  align-items: center;\n  font-size: 15px;\n  opacity: 1;\n  cursor: pointer;\n  animation: fade-in 0.1s ease-in 0s 1;\n}\n\n@keyframes fade-in {\n  0% {\n    opacity: 0;\n    transform: translateY(20px);\n  }\n  100% {\n    opacity: 1;\n    transform: translateY(0px);\n  }\n}\n\n.book-cover-item-desc {\n  width: 240px;\n  margin-top: 5px;\n  font-size: 13px;\n  line-height: 17px;\n  opacity: 0.8;\n  text-align: left;\n  position: relative;\n  float: left;\n  height: 52px;\n}\n.book-cover-item-desc-detail {\n  width: 100%;\n  height: 100%;\n  text-overflow: ellipsis;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 3;\n  overflow: hidden;\n}\n@keyframes slide-down {\n  0% {\n    transform: translateY(-20px);\n    opacity: 0;\n  }\n  100% {\n    transform: translateY(0px);\n    opacity: 1;\n  }\n}\n@keyframes slide-down-rotate {\n  0% {\n    transform: translateY(-20px);\n    opacity: 0;\n  }\n  100% {\n    transform: translateY(0px);\n    opacity: 1;\n  }\n}\n@keyframes slide-up {\n  0% {\n    transform: translateY(20px);\n    opacity: 0;\n  }\n  100% {\n    transform: translateY(0px);\n    opacity: 1;\n  }\n}\n.reading-percentage-char {\n  display: inline-block;\n  transform: scale(0.5) translate(-5px, 2px);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
